// Auto-generate descriptive alt text for hero/marketing images.
// Pattern: "{keyword} in {location} — Colorado Web Impressions"
//
// Used on industry, city hub, and city × service pages so every image
// has unique, keyword-rich alt text without hand-writing it per page.

const BRAND = "Colorado Web Impressions";

function clean(s: string): string {
  return s.trim().replace(/\s+/g, " ");
}

/**
 * Industry hero alt — e.g.
 *   "HVAC marketing in Colorado — Colorado Web Impressions"
 */
export function industryHeroAlt(industryName: string): string {
  const i = clean(industryName);
  return `${i} marketing in Colorado — ${BRAND}`;
}

/**
 * City hub hero alt — e.g.
 *   "Web design and SEO in Colorado Springs, CO — Colorado Web Impressions"
 */
export function cityHubHeroAlt(cityName: string, state = "CO"): string {
  const c = clean(cityName);
  return `Web design and SEO in ${c}, ${state} — ${BRAND}`;
}

/**
 * City × service hero alt — e.g.
 *   "Local SEO in Colorado Springs, CO — Colorado Web Impressions"
 *   "Web Design in Denver, CO — Colorado Web Impressions"
 */
export function cityServiceHeroAlt(
  serviceName: string,
  cityName: string,
  state = "CO",
): string {
  const s = clean(serviceName);
  const c = clean(cityName);
  return `${s} in ${c}, ${state} — ${BRAND}`;
}
